<template>
	<component v-if="isWrapped" :is="tag" v-bind="attributes"><component :is="wrapComponent" v-bind="wrapBind" :object="object" :col="col" v-html="content"></component></component>
	<component v-else :is="tag" v-bind="attributes" v-html="content"></component>
</template>

<script setup lang="ts">
import {type CellBinding, cellData, formatData} from "./AgendaUtils";
import {computed, type CSSProperties, h, createTextVNode} from "vue";
import type {ComponentCell, DataColumn} from "@t/fd/layout/Agenda";
import {injectExecute, injectFindCategory, injectFindList, injectFormData} from "../../PartInjectKeys";
import {injectEnv} from "../../Environment";
import {useListStore} from "@/store/ListStore.ts";

const props = withDefaults(defineProps<{
	object: object,
	col: DataColumn,
	tag?: string
}>(), { tag: "td" });

const formData = injectFormData();
const env = injectEnv();
const ls = useListStore();
const findList = ls.findList;
const findCategory = ls.findCategory;
const execute = injectExecute();

const isWrapped = computed<boolean>(() => typeof props.col.format === "object" && props.col.format.type === "app");

const content = computed<string>(() => {
	let data:Map<string, any> = cellData(props.object, props.col as DataColumn, formData);
	// Include supporting variables
	data.set("$env", env);
	data.set("$findList", findList);
	data.set("$findCategory", findCategory);
	data.set("$execute", execute);
	return formatData(data, props.col as DataColumn);
});
const wrapComponent = computed(() => (props.col.format as ComponentCell).component );
const wrapBind = computed(() => (props.col.format as ComponentCell).bind ?? {} );

const attributes = computed<CellBinding|null>(() => {
	const s:CSSProperties = {};
	if (props.col.align) s.textAlign = props.col.align;

	const bind:CellBinding = {};
	if (Object.keys(s).length > 0) bind.style = s;
	return bind;
});

function contentRender() {
	return createTextVNode('Hello world');
}
</script>

<style scoped>

</style>
